import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AudioComponent} from './audio.component';
import {AudioTrackComponent} from './components/audio-track/audio-track.component';
import {AppleAudioTrackComponent} from './components/apple-audio-track/apple-audio-track.component';

@NgModule({
    declarations: [AudioComponent, AudioTrackComponent, AppleAudioTrackComponent],
    exports: [
        AudioComponent
    ],
    imports: [
        CommonModule
    ]
})
export class AudioModule { }
